import { actionTypes } from "./bookingActions";

const intitialState = {
  rows: [],
  loadingBookings: false,
  filter: {},
  showFormModal: false,
  initialFormValue: null,
  showUpdateDialog: false,
  count: 0,
  order: "asc",
  orderBy: "createdAt",
  page: 0,
  rowsPerPage: 5,
};

export default (state = intitialState, action) => {
  switch (action.type) {
    case actionTypes.SHOW_UPDATE_DIALOG:
      return {
        ...state,
        showUpdateDialog: true,
      };

    case actionTypes.CLOSE_UPDATE_DIALOG:
      return {
        ...state,
        showUpdateDialog: false,
      };

    case actionTypes.FETCH_INIT:
      return {
        ...state,
        page: action.payload.page,
        rowsPerPage: action.payload.limit,
        order: action.payload.order,
        orderBy: action.payload.orderBy,
        loadingBookings: action.payload.loadingScreen,
      };
    case actionTypes.FETCH_SUCCESS:
      return {
        ...state,
        loadingBookings: false,
        rows: action.payload.rows,
        count: action.payload.count,
      };
    case actionTypes.FETCH_ERROR:
      return {
        ...state,
        loadingBookings: false,
      };
    case actionTypes.SET_FILTER:
      return {
        ...state,
        filter: action.payload.filter,
      };

    case actionTypes.SET_PAGE:
      return {
        ...state,
        page: action.payload.page,
      };

    case actionTypes.SET_ORDER:
      return {
        ...state,
        order: action.payload.order,
      };

    case actionTypes.SET_ORDERBY:
      return {
        ...state,
        orderBy: action.payload.orderBy,
      };

    case actionTypes.SET_ROWS_PER_PAGE:
      return {
        ...state,
        rowsPerPage: action.payload.rowsPerPage,
      };

    case actionTypes.UPDATE_ERROR:
    case actionTypes.UPDATE_SUCCESS:
      return {
        ...state,
        showUpdateDialog: false,
      };

    default:
      return state;
  }
};
